/**
 * Blog lista — kategória chip szűrők + AJAX load more.
 *
 *  - Chip click           → toggle aktív / inaktív
 *  - Chip X (aria-pressed=true belül)  → inaktivál (event delegation)
 *  - Bármely chip click   → AJAX fetch + grid replace, offset 0
 *  - "Továbbiak" gomb     → AJAX fetch + grid append, offset = jelenlegi count
 *
 * Backend endpoint: admin-ajax.php?action=drewcore_blog_filter
 * (functions/ajax-blog-filter.php) — JSON {html, has_more, total_found, count}.
 * A nonce + URL a `window.drewcoreBlogFilter` objektumon érkezik
 * (wp_localize_script).
 *
 * A defer + readyState minta a többi section-höz hasonló.
 */
(function () {
  'use strict';

  function init() {
    var cfg = window.drewcoreBlogFilter || {};
    if (!cfg.url || !cfg.nonce) {
      // AJAX nem elérhető — vissza-állunk a section attribútumai alapján
      // (de mivel a backend renderel egy initial batch-et, így is van mit látni).
    }

    var sections = document.querySelectorAll('.blog-cpt-lista');
    sections.forEach(function (sec) { setupSection(sec, cfg); });
  }

  function setupSection(sec, cfg) {
    var itemsEl   = sec.querySelector('.blog-cpt-lista__items');
    var emptyEl   = sec.querySelector('.blog-cpt-lista__empty');
    var chipsRoot = sec.querySelector('.blog-cpt-lista__chips');
    var moreWrap  = sec.querySelector('.blog-cpt-lista__more');
    var moreBtn   = sec.querySelector('.blog-cpt-lista__more-btn');
    var spinner   = sec.querySelector('.blog-cpt-lista__more-spinner');
    var limit     = parseInt(sec.getAttribute('data-limit'), 10) || 6;
    var loadMore  = sec.getAttribute('data-load-more') === '1';

    // Univerzális CPT lista paraméterek
    var postType  = sec.getAttribute('data-post-type') || 'post';
    var taxonomy  = sec.getAttribute('data-taxonomy')  || '';
    var showCats  = sec.getAttribute('data-show-cats') !== '0';
    var showDesc  = sec.getAttribute('data-show-desc') !== '0';

    if (!itemsEl) return;

    // --- Chip toggle ---
    if (chipsRoot) {
      chipsRoot.addEventListener('click', function (e) {
        var chip = e.target.closest('.blog-cpt-lista__chip');
        if (!chip || !chipsRoot.contains(chip)) return;

        var isActive = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', isActive ? 'false' : 'true');

        fetchPage(0, /*append=*/false);
      });
    }

    // --- Load more ---
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var offset = itemsEl.querySelectorAll('.blog-cpt-lista__card').length;
        fetchPage(offset, /*append=*/true);
      });
    }

    // ---------- AJAX core ----------
    function fetchPage(offset, append) {
      if (!cfg.url || !cfg.nonce) return;

      var termIds = collectActiveTermIds();

      setBusy(true, append);

      var body = new URLSearchParams();
      body.set('action', 'drewcore_blog_filter');
      body.set('nonce', cfg.nonce);
      body.set('offset', String(offset || 0));
      body.set('limit', String(limit));
      body.set('post_type', postType);
      body.set('taxonomy', taxonomy);
      body.set('show_cats', showCats ? '1' : '0');
      body.set('show_desc', showDesc ? '1' : '0');
      termIds.forEach(function (id) { body.append('term_ids[]', String(id)); });

      fetch(cfg.url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (!json || !json.success) {
            console.error('Blog filter AJAX error', json);
            return;
          }
          var data = json.data || {};
          renderHtml(data.html || '', append);
          updateLoadMore(!!data.has_more);
        })
        .catch(function (err) {
          console.error('Blog filter AJAX network error', err);
        })
        .then(function () {
          setBusy(false, append);
        });
    }

    function collectActiveTermIds() {
      if (!chipsRoot) return [];
      var ids = [];
      chipsRoot.querySelectorAll('.blog-cpt-lista__chip[aria-pressed="true"]').forEach(function (b) {
        var id = parseInt(b.getAttribute('data-term-id'), 10);
        if (id) ids.push(id);
      });
      return ids;
    }

    function renderHtml(html, append) {
      if (append) {
        itemsEl.insertAdjacentHTML('beforeend', html);
      } else {
        itemsEl.innerHTML = html;
        // scroll-fix: ha hosszabb scroll-pozícióban voltunk, ne ugorjon el
      }
      var hasCards = itemsEl.querySelector('.blog-cpt-lista__card');
      if (emptyEl) {
        if (hasCards) { emptyEl.setAttribute('hidden', ''); }
        else          { emptyEl.removeAttribute('hidden'); }
      }
    }

    function updateLoadMore(hasMore) {
      if (!loadMore || !moreWrap) return;
      if (hasMore) {
        moreWrap.removeAttribute('hidden');
      } else {
        moreWrap.setAttribute('hidden', '');
      }
    }

    function setBusy(isBusy, isLoadMore) {
      itemsEl.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      if (isLoadMore && moreBtn) {
        moreBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        if (spinner) {
          if (isBusy) spinner.removeAttribute('hidden');
          else        spinner.setAttribute('hidden', '');
        }
      }
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
